import { render, staticRenderFns } from "./OfficerOpenRecruitmentPostCreate.vue?vue&type=template&id=bcb97bdc&scoped=true&"
import script from "./OfficerOpenRecruitmentPostCreate.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentPostCreate.vue?vue&type=script&lang=js&"
import style0 from "./OfficerOpenRecruitmentPostCreate.vue?vue&type=style&index=0&id=bcb97bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb97bdc",
  null
  
)

export default component.exports